import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import Login from "./Login.vue";
import Register from "./Register.vue";
import HomePage from "./HomePage.vue";


const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: HomePage,
    meta: {
      title: "Вход"
    }
  },
  {
    path: "/l",
    name: "Login",
    component: Login,
    meta: {
      title: "Вход"
    }
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    meta: {
      title: "Регистрация"
    }
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

export default router;
